/**
 * The OneSignal external id for a profile. A member is its member id, as every sender
 * targets today, so all of a member's logins share it. A login still waiting for its
 * link has no member id and is `au-{appUserId}`: the prefix matters, because a new
 * login's id can equal an unrelated member's id. Once a leader links it, the next
 * profile load returns the member id and OneSignal moves the device to the member.
 */
export function oneSignalExternalId(profile) {
  if (profile?.id) return String(profile.id);
  if (profile?.hasNoMember && profile.appUserId) return `au-${profile.appUserId}`;
  return null;
}
